import type {
  BatchArgs,
  BatchResponse,
  Revision,
  RevisionSourceType,
} from '@carboncopyco/types';
import { Debug } from '@carboncopyco/utils';
import { handleBatchRequest } from '../utils/handleBatchRequest';
import { mainApi } from './mainApi';

Debug.extend('demostack-data:api:revisionApi');

export interface GetRevisionsArgs extends BatchArgs {
  organizationId: string;
  sourceType: RevisionSourceType;
  id: string;
  reverseOrder?: boolean;
}

const revisionApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getRevisions: builder.query<BatchResponse<Revision>, GetRevisionsArgs>({
      query: ({
        organizationId,
        sourceType,
        id,
        reverseOrder = false,
        ...args
      }) =>
        handleBatchRequest({
          ...args,
          url: `/api/${organizationId}/${sourceType}/${id}/revisions`,
          params: { reverseOrder: String(reverseOrder) },
        }),

      providesTags: (_, __, { id, sourceType }) => {
        return [
          { type: 'Revisions', id: sourceType },
          { type: 'Revisions', id },
        ];
      },
    }),
  }),
});

export const { useGetRevisionsQuery, useLazyGetRevisionsQuery } = revisionApi;
